import CustomButton from '@/components/atoms/CustomButton';
import { Text, VStack } from '@chakra-ui/react';

import type { TContentCreatorApplicationSummary } from '@/services/api/requests/contentCreatorApplications';
import ApplicantApplicationInfoCard, {
  ApplicationDetailSection,
  MAX_APPLICANT_INFO_CARD_WIDTH,
} from './ApplicantApplicationInfoCard';
import { extra } from '@/theme/colors/palettes';

const RejectedApplicationDetails = ({
  application,
  onReapply,
}: {
  application: TContentCreatorApplicationSummary;
  onReapply: () => void;
}) => {
  return (
    <VStack minHeight={'100vh'} width={'100vw'} paddingX={'24px'} paddingY={'120px'} spacing={'24px'}>
      <VStack spacing={'10px'} maxWidth={'620px'}>
        <Text
          variant={'loraTitle'}
          color={'white'}
          fontSize={'26px'}
          lineHeight={'32px'}
          fontWeight={'400'}
          textAlign={'center'}
        >
          Application Rejected
        </Text>
        <Text
          color={'white'}
          fontSize={'16px'}
          fontWeight={'500'}
          lineHeight={'22px'}
          textAlign={'center'}
          opacity={0.85}
        >
          Your content creator application was reviewed and was not approved.
        </Text>

        <Text
          color={'white'}
          fontSize={'16px'}
          fontWeight={'500'}
          lineHeight={'22px'}
          textAlign={'center'}
          opacity={0.85}
        >
          You can find your application details below.
        </Text>
      </VStack>

      {application.decisionNotes && (
        <VStack
          width={'100%'}
          maxWidth={MAX_APPLICANT_INFO_CARD_WIDTH}
          backgroundColor={'white'}
          borderRadius={'12px'}
          boxShadow={'0px 16px 60px 0px #00000066'}
          alignItems={'stretch'}
          padding={'26px'}
          spacing={'18px'}
        >
          <ApplicationDetailSection label={'REJECTION REASON'} labelColor={extra.red}>
            <Text color={'text.darkBlue'} fontSize={'15px'} lineHeight={'21px'} fontWeight={'700'}>
              {application.decisionNotes}
            </Text>
          </ApplicationDetailSection>
        </VStack>
      )}

      <ApplicantApplicationInfoCard
        application={application}
        dateLabel={'DECISION DATE'}
        dateValue={application.decidedAt}
      />

      <CustomButton
        label="Reapply"
        onClick={onReapply}
        width={'300px'}
        backgroundColor={'primary.500'}
        labelColor="white"
      />
    </VStack>
  );
};

export default RejectedApplicationDetails;
